import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/offer-add-button.js";
import { OfferRadioButtonType } from "../../common/offer-radio-button.js";
import { PackageToggleOfferElement } from "../../lib/package-toggle-offer-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { FRIENDLY_ERROR_MESSAGE } from "../../lib/utils.js";
import { when } from "lit/directives/when.js";
import "./travel-insurance-package.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let TravelInsurance = class extends PackageToggleOfferElement {
  constructor() {
    super();
    this.coverageType = "BASIC";
    this.product = "travel";
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    return {
      trip_start_date: this.tripStartDate,
      trip_end_date: this.tripEndDate,
      origin: {
        state: this.originState,
        country: this.originCountry
      },
      destination_countries: this.destinationCountries,
      coverage_type: this.coverageType,
      trip_cost: this.tripCost
    };
  }
  _renderStandardDisplay() {
    throw new Error("Method not implemented.");
  }
  render() {
    var _a, _b, _c;
    const packages = Array.from(((_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("travel-insurance-package")) == null ? void 0 : _b.values()) ?? []);
    return (_c = this.productController) == null ? void 0 : _c.render({
      complete: () => html`

        <div id="multi-offer-wrapper">
          <div id="offers">
            ${["COMPREHENSIVE", "BASIC", "COMPREHENSIVE_CFAR"].map((coverageType, i) => html`
              <travel-insurance-package 
                data-unique-id=${i}
                .clientId=${this.clientId} 
                .customerFirstName=${this.customerFirstName} 
                .customerLastName=${this.customerLastName}
                .customerEmailAddress=${this.customerEmailAddress}
                .customerCity=${this.customerCity}
                .customerStreetAddress=${this.customerStreetAddress}
                .customerPostalCode=${this.customerPostalCode}
                .customerState=${this.customerState}
                .destinationCountries=${this.destinationCountries}
                .originCountry=${this.originCountry}
                .originState=${this.originState}
                .tripCost=${this.tripCost}
                .tripStartDate=${this.tripStartDate}
                .tripEndDate=${this.tripEndDate}
                .coverageType=${coverageType}
                .recommended=${coverageType === "COMPREHENSIVE"}
                @offer-state-change=${this.offerStateChangeHandler}
              ></travel-insurance-package>
            `)}
          </div>
          ${when(packages.some((v) => v.quote !== void 0), () => html`
            <div class="decline-action">
              <offer-accordion-header .type=${OfferRadioButtonType.DECLINED} .showIcon=${false} .showPromotionalHeader=${false} @change=${this.decline} .checked=${this.selectedState === SelectedState.DECLINED}>
                <h1>No, do not protect my trip.</h1>
              </offer-accordion-header>
            </div>
            ${when(this.errors.length > 0, () => html`
              <section id="errors">
                ${this.errors.map((e) => html`<p>${FRIENDLY_ERROR_MESSAGE[e]}</p>`)}
              </section>
            `)}
            ${this.renderPaymentElement()}
            <section id="legal-disclaimer">
              <legal-disclaimer></legal-disclaimer>
            </section>
          `)}
        </div>
    `
    });
  }
};
TravelInsurance.styles = [
  PackageToggleOfferElement.styles,
  css`
      :host {
        height: 100%;
        width: 100%;
        max-width: 1024px;
        margin-top: unset;
      }

      #offers {
        margin-top: unset;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: var(--default-vi-package-display-spacing);
      }

      :host {
        min-width: 780px;
      }

      offer-header {
        --default-vi-font-xl: var(--vi-multi-offer-header-font-size); 
      }
    
      @media (max-width: 830px) {
        #multi-offer-wrapper {
          margin-top: unset;
        }
        :host {
          min-width: unset;
        }
      }
    `
];
__decorateClass([
  property({ attribute: "coverage-type" })
], TravelInsurance.prototype, "coverageType", 2);
__decorateClass([
  property({ attribute: "trip-start-date" })
], TravelInsurance.prototype, "tripStartDate", 2);
__decorateClass([
  property({ attribute: "trip-end-date" })
], TravelInsurance.prototype, "tripEndDate", 2);
__decorateClass([
  property({ type: Array, attribute: "destination-countries" })
], TravelInsurance.prototype, "destinationCountries", 2);
__decorateClass([
  property({ type: Number, attribute: "trip-cost" })
], TravelInsurance.prototype, "tripCost", 2);
__decorateClass([
  property({ attribute: "origin-state" })
], TravelInsurance.prototype, "originState", 2);
__decorateClass([
  property({ attribute: "origin-country" })
], TravelInsurance.prototype, "originCountry", 2);
TravelInsurance = __decorateClass([
  customElement("travel-insurance")
], TravelInsurance);
export {
  TravelInsurance
};
